<template>
  <CommonLayout header="customerHeader" footer="customerFooter" ref="commonRef">
    <CustomerMeetingLayout :type="consts.meetingType.customer">
      <BOverlay :show="overlayShow" rounded="sm">
        <div class="base-color h-100 mh-550 shadow">
          <div class="content-wrapper">
            <div class="left-content">
              <h5 class="text-primary p-3 pt-2 mb-2">{{ signalingData['title'] }}</h5>
              <ul class="list-group mb-5">
                <li
                  class="list-group-item border-0"
                  v-for="(content, index) in signalingData['contents']"
                  :key="index"
                >
                  ・{{ content }}
                </li>
              </ul>
            </div>

            <div class="right-content">
              <img class="agenda-image" :src="imageUrl" alt="Agenda Image">
            </div>
          </div>
        </div>
      </BOverlay>
    </CustomerMeetingLayout>

    <!-- florist画面と合わせて配置（今すぐ使わなくてもOK） -->
    <CommonModal ref="commonModal" />
  </CommonLayout>
</template>

<script>
import CommonLayout from '@/layout/CommonLayout'
import CustomerMeetingLayout from '@/layout/CustomerMeetingLayout'
import CommonModal from '@/components/CommonModal'
import SignalingModel from '@/models/SignalingModel'
import CommonLogModel from '@/models/CommonLogModel'
import cstore from '@/store/customer-store'
import mstore from '@/store/meeting-store'
import { useModal } from 'bootstrap-vue-next'

export default {
  name: 'CustomerMeetingAgenda',
  components: { CommonLayout, CustomerMeetingLayout, CommonModal },
  data () {
    return {
      overlayShow: false,
      signalingData: [],
      imageUrl: '',
      customerDisplayFlag: cstore.getters.customerDisplayFlag === null ? false : cstore.getters.customerDisplayFlag
    }
  },
  mounted () {
    this.imageUrl = this.config.imageURL + '/meeting-contents/agenda.jpg'
  },
  computed: {
    getSignalingData () {
      return cstore.getters.signalingReceiveData
    },
    getIsTargetAtendeeActive () {
      return mstore.getters.isTargetAtendeeActive
    }
  },
  watch: {
    getSignalingData (newData, oldData) {
      try {
        newData['user'] = 'customer'
        newData['timestampMs'] = Date.now()
        // $bvModal → this.modal
        CommonLogModel.apiSetStore(this.$refs.commonModal, newData, () => {})

        if (newData['current_path'] && oldData) {
          const synchPass = newData['current_path'].replace('florist', 'customer')
          if (synchPass !== this.$route.path) {
            return this.$router.push(synchPass)
          }
        }

        if (newData['event'] === 'click') {
          if (newData['id'] === 'next') {
            this.$router.push(newData['target_path'])
          }
          if (newData['id'] === 'reload') {
            this.signalingData = []
          }
          if (newData['id'] === 'priceHide') {
            cstore.commit('setCustomerDisplayFlag', false)
            this.customerDisplayFlag = cstore.getters.customerDisplayFlag
          } else if (newData['id'] === 'priceDisplay') {
            cstore.commit('setCustomerDisplayFlag', true)
            this.customerDisplayFlag = cstore.getters.customerDisplayFlag
          }
        }

        if (newData['event'] === 'api') {
          this.signalingData = newData.data.agenda
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$refs.commonModal, { timestampMs: Date.now(), error: err }, () => {})
      }
    },
    getIsTargetAtendeeActive (newData, oldData) {
      if (newData) {
        SignalingModel.sendStatusEvent({ show_agenda_view: 'success' })
      }
    }
  }
}
</script>

<style scoped>
.agenda-image {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
}

.content-wrapper {
  display: flex;
  flex: 1;
  width: 100%;
  padding: 0;
  margin: 0;
  overflow: hidden;
}

.left-content {
  width: 58.333333%;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
}

.right-content {
  width: 41.666667%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
}
</style>
